<template>
  <div class="flex justify-center w-full h-full flex-col items-center gap-y-2">
    <img
      src="@/app/ui/assets/svg/no-data-list.svg"
      alt="not-data-list"
      width="160"
      height="135"
    />
    <div class="text-sm text-gray-lp-600">
      Belum ada paket yang di dispatch
    </div>
  </div>
</template>
